module.exports = __webpack_public_path__ + "media/images/flags/4x3/cuw-e95152b925e733bddbeda10b634bd458.svg";